import get from './get.js';

const base = 'api/backup';

export default {
	list: (params) => get(base + '/list', params),
};
